import { useIonViewDidEnter, useIonViewDidLeave } from '@ionic/react';
import { useContext, useEffect, useState } from 'react';
import { MessageContext } from '../contexts/MessageContext';
import { empresaCarregar } from '../Utils/Services';

// Atualiza apenas os dados de pausa da loja, sem recarregar o carrinho ou o catálogo.
export function useDeliveryStatus() {
  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);
  const [active, setActive] = useState(false);
  const storeId = dadosEmpresa?.pk;
  useIonViewDidEnter(() => setActive(true));
  useIonViewDidLeave(() => setActive(false));

  useEffect(() => {
    if (!active || !storeId) return;
    let disposed = false;
    let pending: AbortController | undefined;
    const refresh = async () => {
      if (document.visibilityState === 'hidden' || pending) return;
      const controller = new AbortController();
      pending = controller;
      const timeout = window.setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(empresaCarregar.url.replace('{id}', encodeURIComponent(storeId)), {
          method: empresaCarregar.method,
          cache: 'no-store',
          signal: controller.signal,
          headers: Object.fromEntries(['token', 'versao', 'perfil', 'marca'].map(key => [key, localStorage.getItem(key) || ''])),
        });
        if (!response.ok) return;
        const { Item: company } = await response.json();
        if (disposed || company?.pk !== storeId) return;
        setDadosEmpresa((current: any) => {
          if (current?.pk !== storeId) return current;
          const deliveryFechado = company.deliveryFechado === true;
          const deliveryFechadoMotivo = deliveryFechado && typeof company.deliveryFechadoMotivo === 'string'
            ? company.deliveryFechadoMotivo.trim() : '';
          if (current.deliveryFechado === deliveryFechado && current.deliveryFechadoMotivo === deliveryFechadoMotivo
            && current.deliveryFechadoAt === company.deliveryFechadoAt) return current;
          return { ...current, deliveryFechado, deliveryFechadoMotivo, deliveryFechadoAt: company.deliveryFechadoAt };
        });
      } catch {
        // Uma falha de atualização não interrompe a navegação; a próxima entrada ou foco tenta novamente.
      } finally {
        window.clearTimeout(timeout);
        pending = undefined;
      }
    };
    refresh();
    // Polling periódico desativado: o status é consultado ao entrar na tela ou voltar à aba.
    // const interval = window.setInterval(refresh, 30000);
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('focus', refresh);
    return () => {
      disposed = true;
      // window.clearInterval(interval);
      pending?.abort();
      document.removeEventListener('visibilitychange', refresh);
      window.removeEventListener('focus', refresh);
    };
  }, [active, storeId, setDadosEmpresa]);
}
